/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import Logo from 'assets/images/logo.png';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import UnifiedWishlist from './components/UnifiedWishlist';
import CaptureAds from './components/CaptureAds';
import Button from 'shared/components/Button';
import SnapSave from './components/SnapSave';
import GiftList from './components/GiftList';
import Shopping from './components/Shopping';
import PreloadImagesComponent from './components/PreloadImages';
import { isMobileSize } from 'shared/utils/appHelpers';
import { URLS } from 'configs';

const Onboarding = ({ history }) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [animation, setAnimation] = useState(0);
  const isMobile = isMobileSize(window.innerWidth);

  const steps = [
    {
      component: UnifiedWishlist,
      title: 'onboarding_unified_wishlist_title',
      desc: 'onboarding_unified_wishlist_desc',
      animationCount: 1,
      className: '',
    },
    {
      component: CaptureAds,
      title: 'onboarding_organize_ad_title',
      desc: 'onboarding_organize_ad_desc',
      animationCount: 2,
      className: '',
    },
    {
      component: SnapSave,
      title: 'onboarding_snap_save_title',
      desc: 'onboarding_snap_save_desc',
      animationCount: 1,
      className: '',
    },
    {
      component: GiftList,
      title: 'onboarding_gift_list_title',
      desc: 'onboarding_gift_list_desc',
      className: 'onboarding-gift-list pt-10',
      animationCount: 1,
    },
    {
      component: Shopping,
      title: 'onboarding_shopping_title',
      desc: 'onboarding_shopping_desc',
      animationCount: 1,
      className: '',
    },
  ];

  const onHandleNext = () => {
    if (step < steps.length - 1) {
      setStep(step + 1);
    } else {
      window.location.assign(URLS.CONTACT);
    }
  };

  const onHandleMobileNext = activeStep => {
    if (animation >= activeStep.animationCount) {
      onHandleNext();
      setAnimation(0);
    } else {
      setAnimation(animation + 1);
    }
  };

  const activeStep = steps[step];
  const ActiveStepComponent = activeStep.component;

  return (
    <div className={`wrapper on-page-onboarding d-flex flex-column justify-content-md-between`}>
      <header className='landing bg-none py-7 py-md-12 z-index-4 t-0 l-0 r-0 position-relative'>
        <div className='container'>
          <div className='d-flex align-items-center justify-content-between'>
            <Link to='/'>
              <img src={Logo} alt='Logo' className='w-118-px w-162-px-md' />
            </Link>
            <p className='mb-0'>
              <a href={URLS.CONTACT} className='text-body text-underline fw-600'>
                {t('text_skip')}
              </a>
            </p>
          </div>
        </div>
      </header>
      <div className={`main-content mt-0 d-flex flex-column  ${activeStep.className || ''}`}>
        <div className='container pt-20 px-0' onClick={isMobile ? onHandleMobileNext.bind(null, activeStep) : null}>
          <section>
            <div className='container pb-15'>
              <div className='d-flex flex-wrap flex-md-nowrap align-items-center'>
                <div className='w-100 mxw-548-px-md mr-md-16'>
                  <h3 className='mb-8 mb-md-15'>{t(activeStep.title)}</h3>
                  <p className='mb-12 mb-md-15'>
                    <Trans i18nKey={activeStep.desc} />
                  </p>
                  <Button className='btn-primary d-none d-md-block' onClick={onHandleNext}>
                    {t('btn_next')}
                  </Button>
                </div>
                <div className='image-area'>
                  <ActiveStepComponent animationCount={animation} />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className='d-md-none btn-block px-8 py-5 z-index-100 position-relative'>
        <Button className='btn-primary btn-block' onClick={onHandleMobileNext.bind(null, activeStep)}>
          {t('btn_next')}
        </Button>
      </div>
      <div className='d-none onboarding-steps d-md-flex align-items-center justify-content-center pb-20 pt-5'>
        {steps.map((_, index) => (
          <div
            aria-hidden='true'
            tabIndex={-1}
            onClick={() => setStep(index)}
            key={index}
            className={`cursor-pointer step ${step === index ? 'active' : ''}`}
          />
        ))}
      </div>
      <PreloadImagesComponent />
    </div>
  );
};

export default Onboarding;
